import axios from "axios";

const API_SOPLANNING_URL = process.env.REACT_APP_ATIS_PLANNING_API_BASE_URL;
const API_SOPLANNING_KEY_NAME = process.env.REACT_APP_ATIS_PLANNING_API_KEY_NAME;
const API_SOPLANNING_KEY_VALUE = process.env.REACT_APP_ATIS_PLANNING_API_KEY_VALUE;


export const getSoPlanningProjects = () => {
  return axios.get(`${API_SOPLANNING_URL}/projects`, {
      headers: { [API_SOPLANNING_KEY_NAME] : API_SOPLANNING_KEY_VALUE },
      cache: 'no-cache',
    });
}
// 23/10/2026 : lecture des taches (grille de planning), lecture seule
export const getSoPlanningTasks = (startDate, endDate) => {
  return axios.get(`${API_SOPLANNING_URL}/tasks?start_date=${startDate}&end_date=${endDate}&t=${Date.now()}`, {
      headers: { [API_SOPLANNING_KEY_NAME] : API_SOPLANNING_KEY_VALUE },
      cache: 'no-cache',
    });
}
export const getSoPlanningUsers = () => {
  return axios.get(`${API_SOPLANNING_URL}/users`, {
      headers: { [API_SOPLANNING_KEY_NAME] : API_SOPLANNING_KEY_VALUE },
      cache: 'no-cache',
    });
}

const addPlanningTaskRaw = (task) => {
  const { taskId, userId, projectId, startDate, endDate, statusId, title, creatorId } = task; 
  /*console.log(title);
  console.log(encodeURI(title));
  console.log(encodeURIComponent(title));*/
  const taskIdVal = taskId ? `=${taskId}` : "";
  let urlParam = `?task_id${taskIdVal}&user_id=${userId}&project_id=${projectId}&link_id&`
  urlParam += `start_date=${startDate}&end_date=${endDate}&`
  urlParam += `start_time&end_time&duration&status_id=${statusId}&`
  urlParam += "title="+encodeURIComponent(title)
  urlParam += `&comment&link&resource_id=&place_id&milestone=&`
  urlParam += `custom_field=&creator_id=${creatorId}`
 return axios(`${API_SOPLANNING_URL}/tasks${urlParam}`, {
    headers: { [API_SOPLANNING_KEY_NAME] : API_SOPLANNING_KEY_VALUE },
    method: "POST"
  });
}

// 13/10/2026 : tache SOPlanning supprimee (400 "task_id unknown") -> on recree une tache
export const addPlanningTask = (task) => {
  return addPlanningTaskRaw(task).catch((error) => {
    const r = error && error.response;
    const body = r && r.data ? JSON.stringify(r.data) : "";
    if (task && task.taskId && r && r.status === 400 && body.indexOf("task_id unknown") >= 0) {
      return addPlanningTaskRaw(Object.assign({}, task, { taskId: null }));
    }
    throw error;
  });
};


// 24/10/2026 : intervenants multiples (taches liees, meme link_id) et projets
export const getSoPlanningTask = (taskId) => {
  return axios.get(`${API_SOPLANNING_URL}/tasks/${taskId}?t=${Date.now()}`, {
      headers: { [API_SOPLANNING_KEY_NAME] : API_SOPLANNING_KEY_VALUE },
      cache: 'no-cache',
    });
}

export const addSoPlanningLinkedTask = (task) => {
  const { taskId, userId, projectId, linkId, startDate, endDate, statusId, title, creatorId } = task;
  const taskIdVal = taskId ? `=${taskId}` : "";
  let urlParam = `?task_id${taskIdVal}&user_id=${encodeURIComponent(userId)}&project_id=${encodeURIComponent(projectId)}`
  urlParam += `&link_id=${encodeURIComponent(linkId || "")}&`
  urlParam += `start_date=${startDate}&end_date=${endDate || startDate}&`
  urlParam += `start_time&end_time&duration&status_id=${encodeURIComponent(statusId || "a_faire")}&`
  urlParam += "title=" + encodeURIComponent(title || "")
  urlParam += `&comment&link&resource_id=&place_id&milestone=&`
  urlParam += `custom_field=&creator_id=${encodeURIComponent(creatorId || "")}`
  return axios(`${API_SOPLANNING_URL}/tasks${urlParam}`, {
    headers: { [API_SOPLANNING_KEY_NAME] : API_SOPLANNING_KEY_VALUE },
    method: "POST"
  });
}

export const deleteSoPlanningTask = (taskId) => {
  return axios(`${API_SOPLANNING_URL}/tasks/${taskId}`, {
    headers: { [API_SOPLANNING_KEY_NAME] : API_SOPLANNING_KEY_VALUE },
    method: "DELETE"
  });
}

// creation ou modification d'un projet (PUT projects/{id}) ; les champs non fournis gardent la valeur transmise (p.*)
export const saveSoPlanningProject = (p) => {
  const q = (k, v) => `${k}=${encodeURIComponent(v == null ? "" : v)}`;
  const params = [
    q("name", p.name), q("owner_id", p.owner_id || "jlouis"), q("status_id", p.status || "a_faire"),
    q("delivery", p.delivery), q("color", String(p.color || "").replace("#", "")), q("link", p.link),
    q("comment", p.comment), q("group_id", p.group_id), q("budget_amount", p.budget_amount), q("budget_time", p.budget_time),
  ].join("&");
  return axios(`${API_SOPLANNING_URL}/projects/${encodeURIComponent(p.id)}?${params}`, {
    headers: { [API_SOPLANNING_KEY_NAME] : API_SOPLANNING_KEY_VALUE },
    method: "PUT"
  });
}



// WEBPACK FOOTER //
// ./src/store/external/soplanning.js